import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useState,
} from "react";
import { MeasurementType } from "../../../viewer/measurement/types";

/**
 * "Edit (Measurement Result)" mode state (SC_QUICK-2187, QU3DW-1367).
 * Shared so the Tick/X buttons in the measurement toolbar (CalcTabPanel) can
 * drive the panel-position save/cancel implemented in CalcDrawerContent,
 * instead of the toolbar's default measurement-edit behaviour.
 */
export type TMeasurementResultEditState = {
  active: boolean;
  /** True once the panel has actually been dragged (VR-1: Tick becomes active). */
  changed: boolean;
  /** True while the PATCH request is in flight (AC-10: Tick/X disabled). */
  saving: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
};

export const INITIAL_MEASUREMENT_RESULT_EDIT: TMeasurementResultEditState = {
  active: false,
  changed: false,
  saving: false,
};

export type CalcContextType = {
  measurementType: MeasurementType;
  setMeasurementType: Dispatch<SetStateAction<MeasurementType>>;
  onEditingMode: boolean;
  setOnEditingMode: (value: boolean) => void;
  measurementResultEdit: TMeasurementResultEditState;
  setMeasurementResultEdit: Dispatch<
    SetStateAction<TMeasurementResultEditState>
  >;
};

export const CalcContext = createContext<CalcContextType>(
  {} as CalcContextType
);

export default CalcContext;

export const CalcContextProvider = (props: { children: ReactNode }) => {
  const [measurementType, setMeasurementType] = useState<MeasurementType>(null);
  const [onEditingMode, setOnEditingMode] = useState<boolean>(false);
  const [measurementResultEdit, setMeasurementResultEdit] =
    useState<TMeasurementResultEditState>(INITIAL_MEASUREMENT_RESULT_EDIT);

  const contextValue = {
    measurementType,
    setMeasurementType,
    onEditingMode,
    setOnEditingMode,
    measurementResultEdit,
    setMeasurementResultEdit,
  };

  return (
    <CalcContext.Provider value={contextValue}>
      {props.children}
    </CalcContext.Provider>
  );
};
